export { default } from 'ky';